
























import { mapGetters } from 'vuex';
import type { PropType } from 'vue';
import { IThumbnailConfig } from '@/helpers/StreamerThumbnailConfigs';

export default {
  name: 'ThumbnailStreamerPreview',
  props: {
    thumbnailConfig: {
      type: Object as PropType<IThumbnailConfig>,
      required: true
    },
    streamerImageUrl: {
      type: String,
      default: null
    },
    streamerNickname: {
      type: String,
      default: 'Unknown'
    },
    customAppName: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters('Onboarding', ['copyStakeAppName']),

    templateImageUrl(): string {
      return this.thumbnailConfig.templateImageUrl;
    },
    templateImageWidth(): string {
      return this.thumbnailConfig.templateImageWidth;
    },
    templateImageHeight(): string {
      return this.thumbnailConfig.templateImageHeight;
    },
    streamerImageWidth(): string {
      return this.thumbnailConfig.streamerImageWidth;
    },
    streamerImageHeight(): string {
      return this.thumbnailConfig.streamerImageHeight;
    },

    formattedStreamerNickname(): string {
      return this.streamerNickname.trim();
    },
    formattedAppName(): string {
      const name =
        (this.customAppName ? this.customAppName : this.copyStakeAppName) ||
        'Unknown';

      return Array.from({ length: 20 }, () => name).join('  ');
    },

    previewTemplateStyles(): any {
      return {
        '--card-width': `${this.templateImageWidth}px`,
        '--card-height': `${this.templateImageHeight}px`,
        '--streamer-image-width': `${this.streamerImageWidth}px`,
        '--streamer-image-height': `${this.streamerImageHeight}px`,
        '--nickname-max-width': `${this.thumbnailConfig.nicknameMaxWidth}px`,
        '--nickname-bottom-position': `${this.thumbnailConfig.nicknameBottomPosition}px`,
        '--app-name-bottom-position': `${this.thumbnailConfig.appNameBottomPosition}px`,
        '--app-name-background-color':
          this.thumbnailConfig.appNameBackgroundColor
      };
    }
  }
};
